<!--
* @description  参数1
* @fileName  actionIndex
* @author userName
* @date 2024-01-19 15:53:28
!-->
<template>
  <div>
    <div class="group-main">
      <div class="group-main-aside">
        <ByFold :list="menuList" @getActive="getActive" @isOpen="isOpen" />
      </div>
      <div class="group-main-container">
        <BillingDetails v-if="activeName == '付款方式'" ref="BillingDetails" @next="next" @finish="finish" />
        <ContactIndex
          v-if="showContact"
          ref="ContactIndex"
          :active-name="activeName"
          @next="next"
          @finish="finish"
        />
        <Commodities
          v-if="activeName=='货物信息'"
          ref="Commodities"
          :active-name="activeName"
          @next="next"
          @finish="finish"
        />
        <Invoice
          v-if="activeName=='文件上传'"
          ref="Invoice"
          :active-name="activeName"
          @next="next"
          @finish="finish"
        />
      </div>
    </div>
    <CancelShipment ref="cancelSh" @confirm="finish" />
  </div>
</template>

<script>
import ByFold from '../../../../../../components/byFold/byFold.vue'
import BillingDetails from './billingDetails.vue'
import ContactIndex from './contactDetails/contactIndex.vue'
import Commodities from './yourGoods/commodities.vue'
import Invoice from './yourGoods/invoice.vue'
import CancelShipment from './cancelShipment.vue'
import {
  CheckOrderCompleteDetail
} from '@/api/order.js'
export default {
  name: 'ActionIndex',
  components: {
    // 组件的引用
    ByFold,
    BillingDetails,
    ContactIndex,
    Commodities,
    Invoice,
    CancelShipment
  },
  props: {
    // 父辈向子辈传参

  },
  data() {
    return {
      isCancelDialog: false,
      data: {},
      menuList: [{
        name: '付款',
        isTrue: true,
        child: [{
          name: '付款方式',
          isActive: true
        }]
      },
      {
        name: '联系方式',
        isTrue: false,
        child: [{
          name: '取件地址',
          isActive: false
        },
        {
          name: '发件人地址',
          isActive: false
        },
        {
          name: '派送地址',
          isActive: false
        },
        {
          name: '收件人地址',
          isActive: false
        }
        ]
      },
      {
        name: '货物信息',
        isTrue: false,
        child: [{
          name: '货物信息',
          isActive: false
        },
        {
          name: '文件上传',
          isActive: false
        }
        ]
      }
      ],
      activeName: ''
    }
  },
  computed: {

    // 计算属性
    showContact() {
      return ['取件地址', '发件人地址', '派送地址', '收件人地址'].some(
        (item) => this.activeName == item
      )
    }
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容

  },
  methods: {
    next(stepName, index) {
      this.activeName = stepName
      this.getActive({
        name: stepName,
        isActive: false
      }, index)
      this.menuList.forEach((item, index) => {
        item.child.forEach((item1, index1) => {
          if (item1.name === stepName) {
            this.isOpen(item, index)
            this.getActive(item1, index1)
          }
        })
      })
      this.checkOrder()
    },
    checkOrder() {
      CheckOrderCompleteDetail(this.data.orderNo).then(res => {
        if (res.code === 200) {
          var completeList = res.data.completeList
          var incompleteList = res.data.incompleteList
          completeList.forEach(stepName => {
            this.menuList.forEach((item, index) => {
              item.child.forEach((item1, index1) => {
                if (item1.name === stepName) {
                  item1.isFinish = true
                }
              })
            })
          })
          incompleteList.forEach(stepName => {
            this.menuList.forEach((item, index) => {
              item.child.forEach((item1, index1) => {
                if (item1.name === stepName) {
                  item1.isFinish = false
                }
              })
            })
          })
        }
      })
    },
    cancelShip() {
      this.$refs.cancelSh.init(this.data)
    },
    finish() {
      this.$emit('finish')
    },
    init(data) {
      this.data = data
      this.getActive({
        name: '付款方式',
        isActive: false
      }, 0)
      this.checkOrder()
    },
    // 方法
    isOpen(item, index) {
      this.menuList.forEach((res, i) => {
        if (index == i) {
          this.$set(res, 'isTrue', true)
          this.getActive(item.child[0], 0)
        } else {
          this.$set(res, 'isTrue', false)
        }
      })
    },
    getActive(item, index) {
      console.log('data-----------111')
      console.log(this.data)
      this.activeName = item.name
      if (this.activeName === '付款方式') {
        this.$nextTick(() => {
          this.$refs.BillingDetails.init(this.data)
        })
      }
      if (['取件地址', '发件人地址', '派送地址', '收件人地址'].some((item) => this.activeName == item)) {
        this.$nextTick(() => {
          this.$refs.ContactIndex.init(this.data, index)
        })
      }
      if (this.activeName === '货物信息') {
        this.$nextTick(() => {
          this.$refs.Commodities.init(this.data)
        })
      }
      if (this.activeName === '文件上传') {
        this.$nextTick(() => {
          this.$refs.Invoice.init(this.data)
        })
      }
      if (this.activeName === 'POA') {
        this.$nextTick(() => {
          this.$refs.POA.init(this.data)
        })
      }
      this.menuList.forEach(res => {
        res.child.forEach((list, j) => {
          if (index == j) {
            this.$set(list, 'isActive', true)
          } else {
            this.$set(list, 'isActive', false)
          }
        })
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.confirmOrder-title-font {
		font-size: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 600;
		color: #333333;
	}

	.actionIndex {
		width: 1168px;
		height: 140px;
		background: #FFFFFF;
		border-radius: 8px;
		padding: 16px;
		margin-top: 16px;

		.card-bg {
			display: block;
			text-align: center;
			width: 1168px;
			height: 56px;
			background: url("../../../../../../assets/img/client/booking/bg_xiadan.png");
			background-size: 1168px 100px;
			padding: 22px 0;

			div:nth-of-type(1) {
				@extend .confirmOrder-title-font;
				margin-bottom: 11px;
			}

			div:nth-of-type(2) {
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #777777;
			}
		}

		.card-default {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin: 17px 0;

			.card-l {
				display: flex;
				font-size: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				color: #333333;

				img {
					margin-right: 8px;
				}
			}

			.card-r {
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #027FFC;
				cursor: pointer;
			}
		}

	}

	.group-main {
		display: flex;
		margin: 16px 0;

		.group-main-aside {
			width: 180px;
			height: auto;
			border-radius: 8px;
			background: rgba(216, 216, 216, 0);
			margin-right: 24px;
		}

		.group-main-container {
			// width: 996px;
			// height: auto;
			// background: #FFFFFF;
			// border-radius: 8px;

		}
	}
</style>
